<ng-container *ngIf="isAccountGroupPartnerType$ | async">
  <ng-container *ngIf="assignedContact$ | async as salesContact">
    <div class="name-and-avatar">
      <div class="assignee">{{ 'INBOX.TOPBAR.ASSIGNEE' | translate }}:</div>
      <glxy-avatar
        *ngIf="salesContact.image !== null"
        [src]="salesContact.image"
        [name]="salesContact.name ?? undefined"
        [width]="16"
      ></glxy-avatar>
      <div>{{ salesContact.name }}</div>
    </div>
  </ng-container>
</ng-container>
